var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nocardpage"},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"block imgbox"},[_c('img',{staticClass:"nocardpic",attrs:{"src":require("../../assets/images/addcard.png"),"alt":""}})]),_vm._v(" "),_c('span',{staticClass:"block"},[_vm._v("请先添加就诊卡")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64b7a03e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/waitinginfo/nocard.vue
// module id = null
// module chunks = 